import React from "react";

const Loader = ({ style }) => {
  return (
    <div
      className="spinner-border"
      role="status"
      style={{
        width: "100px",
        height: "100px",
        margin: "auto",
        marginTop: "200px",
        marginBottom: "200px",
        display: "block"
      }}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Loader;
